import styled from "styled-components";

// Legacy export kept for backward compatibility with old BasicInformation.js / AdditionalInformation.js
export const FormStepWrapper = styled.div``;

export const WizardWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: transparent;
  padding: 0;
  min-height: 100%;

  .wizard-card {
    max-width: 860px;
    width: 100%;
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.09);
    display: flex;
    flex-direction: column;
    height: calc(90vh - 40px);
    overflow: hidden;
  }

  .wizard-header {
    padding: 14px 28px;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
    background: white;
    border-radius: 16px 16px 0 0;
  }

  .progress-bar {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 10px;
    gap: 0;
  }

  .progress-step {
    display: flex;
    align-items: flex-start;
  }

  .step-node {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }

  .step-dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #e2e8f0;
    transition: all 0.3s ease;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #94a3b8;

    &.active {
      background: #01d9a9;
      box-shadow: 0 0 0 4px rgba(1, 217, 169, 0.2);
      color: white;
    }

    &.completed {
      background: #014c75;
      color: white;
    }
  }

  .step-name {
    font-size: 10px;
    font-weight: 600;
    color: #94a3b8;
    white-space: nowrap;
    text-align: center;
    max-width: 80px;

    &.active {
      color: #01d9a9;
    }

    &.completed {
      color: #014c75;
    }
  }

  .step-line {
    width: 64px;
    height: 3px;
    background: #e2e8f0;
    margin: 13px 6px 0;
    flex-shrink: 0;
    transition: background 0.3s ease;

    &.completed {
      background: #014c75;
    }
  }

  .step-info {
    text-align: center;

    .step-label {
      font-size: 12px;
      color: #94a3b8;
      margin-bottom: 2px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .step-title {
      font-size: 18px;
      font-weight: 700;
      color: #014c75;
      margin: 0;
      line-height: 1.2;
    }

    .step-description {
      font-size: 12px;
      color: #64748b;
      margin-top: 2px;
    }
  }

  .wizard-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 28px;
    min-height: 0;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #e2e8f0;
      border-radius: 2px;
    }
  }

  .wizard-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 28px;
    border-top: 1px solid #e8e8e8;
    background: #fafafa;
    border-radius: 0 0 16px 16px;
    flex-shrink: 0;

    .step-counter {
      font-size: 13px;
      color: #94a3b8;
      font-weight: 500;
    }

    .nav-buttons {
      display: flex;
      gap: 10px;
    }
  }

  .ant-form-item {
    margin-bottom: 14px;

    .ant-form-item-label > label {
      font-size: 13px;
      font-weight: 600;
      color: #334155;
    }

    .ant-input,
    .ant-input-affix-wrapper,
    .ant-select-selector,
    .ant-picker,
    .ant-input-number {
      border-radius: 8px !important;
      border: 1.5px solid #e2e8f0 !important;
      font-size: 14px !important;

      &:hover {
        border-color: #cbd5e1 !important;
      }
    }

    /* strip inner input border inside prefix/suffix wrapper — border lives on the wrapper */
    .ant-input-affix-wrapper .ant-input {
      border: none !important;
      box-shadow: none !important;
    }

    .ant-input-affix-wrapper:focus,
    .ant-input-affix-wrapper-focused,
    .ant-input:focus,
    .ant-picker-focused {
      border-color: #94a3b8 !important;
      box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.12) !important;
    }
  }

  .section-title {
    font-size: 13px;
    font-weight: 600;
    color: #014c75;
    margin-bottom: 12px;
    padding-bottom: 6px;
    border-bottom: 2px solid #f1f5f9;
  }
`;

export const WizardButton = styled.button`
  height: 40px;
  padding: 0 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;

  &.cancel-btn, &.back-btn {
    background: white;
    color: #64748b;
    border: 1.5px solid #e2e8f0;

    &:hover {
      border-color: #014c75;
      color: #014c75;
    }
  }

  &.next-btn {
    background: linear-gradient(135deg, #01d9a9 0%, #00b894 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(1, 217, 169, 0.3);
    padding: 0 28px;

    &:hover {
      box-shadow: 0 6px 16px rgba(1, 217, 169, 0.4);
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  }

  &.submit-btn {
    background: linear-gradient(135deg, #014c75 0%, #013a5c 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(1, 76, 117, 0.3);
    padding: 0 28px;

    &:hover {
      box-shadow: 0 6px 16px rgba(1, 76, 117, 0.4);
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  }
`;
